const PaginationConstants = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PHARMACY_LIST_SIZE: 1000,
}

export default PaginationConstants
